import React from "react";
import Loader from "shared/components/loader/circular"
import styles from "./style.module.scss";


interface BtnProps extends React.HTMLProps<HTMLButtonElement> {
  text: string;
  buttonStyle: any;
  type: any;
  handleClick: any;
  loader: boolean;
}

export const LoaderContent = ({
  loader,
  children,
}: {
  loader?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <span className={styles.content}>
      <span className={loader ? styles.hiddenText : undefined}>{children}</span>
      {loader && <Loader />}
    </span>
  );
};

const CustomButton = ({
  text,
  buttonStyle,
  type,
  handleClick,
  loader,
  disabled,
}: Partial<BtnProps>) => {
  return (
    <button
      className={
        buttonStyle ? `${buttonStyle} ${styles.button}` : styles.button
      }
      type={type}
      onClick={handleClick}
      disabled={disabled || loader}
    >
      <LoaderContent loader={loader}>{text}</LoaderContent>
    </button>
  );
};

export default CustomButton;
